"use strict";

var _defineProperty = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/defineProperty.js");

var _common_enums_1$Compa, _common_enums_1$Compa2, _common_enums_1$Compa3, _exports$PHONE_NUMBER;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PHONE_NUMBERS = exports.CENTRAL_STEEL = exports.SOUTHERN_TOOL_STEEL = exports.RYERSON_CN = exports.RYERSON_MX = exports.RYERSON_CA = exports.RYERSON_US = void 0;

var common_enums_1 = require("@ryerson/common.enums");

exports.RYERSON_US = {
  vanity: "+1-855-RYERSON",
  number: "+1-855-793-7766",
  value: "+18557937766"
};
exports.RYERSON_CA = {
  vanity: "+1-844-RYMETAL",
  number: "+1-844-796-3825",
  value: "+18447963825"
};
exports.RYERSON_MX = exports.RYERSON_US;
exports.RYERSON_CN = exports.RYERSON_US;
exports.SOUTHERN_TOOL_STEEL = {
  vanity: "+1-800-487-6382",
  number: "+1-800-487-6382",
  value: "+18004876382"
};
exports.CENTRAL_STEEL = {
  vanity: "+1-800-621-8510",
  number: "+1-800-621-8510",
  value: "+18006218510"
};
exports.PHONE_NUMBERS = (_exports$PHONE_NUMBER = {}, _defineProperty(_exports$PHONE_NUMBER, common_enums_1.Company.RYERSON, (_common_enums_1$Compa = {}, _defineProperty(_common_enums_1$Compa, common_enums_1.CountryEnum.ECountry.us, exports.RYERSON_US), _defineProperty(_common_enums_1$Compa, common_enums_1.CountryEnum.ECountry.ca, exports.RYERSON_CA), _defineProperty(_common_enums_1$Compa, common_enums_1.CountryEnum.ECountry.mx, exports.RYERSON_MX), _defineProperty(_common_enums_1$Compa, common_enums_1.CountryEnum.ECountry.cn, exports.RYERSON_CN), _common_enums_1$Compa)), _defineProperty(_exports$PHONE_NUMBER, common_enums_1.Company.SOUTHERN_TOOL_STEEL, (_common_enums_1$Compa2 = {}, _defineProperty(_common_enums_1$Compa2, common_enums_1.CountryEnum.ECountry.us, exports.SOUTHERN_TOOL_STEEL), _defineProperty(_common_enums_1$Compa2, common_enums_1.CountryEnum.ECountry.ca, exports.SOUTHERN_TOOL_STEEL), _defineProperty(_common_enums_1$Compa2, common_enums_1.CountryEnum.ECountry.mx, exports.SOUTHERN_TOOL_STEEL), _defineProperty(_common_enums_1$Compa2, common_enums_1.CountryEnum.ECountry.cn, exports.SOUTHERN_TOOL_STEEL), _common_enums_1$Compa2)), _defineProperty(_exports$PHONE_NUMBER, common_enums_1.Company.CENTRAL_STEEL, (_common_enums_1$Compa3 = {}, _defineProperty(_common_enums_1$Compa3, common_enums_1.CountryEnum.ECountry.us, exports.CENTRAL_STEEL), _defineProperty(_common_enums_1$Compa3, common_enums_1.CountryEnum.ECountry.ca, exports.CENTRAL_STEEL), _defineProperty(_common_enums_1$Compa3, common_enums_1.CountryEnum.ECountry.mx, exports.CENTRAL_STEEL), _defineProperty(_common_enums_1$Compa3, common_enums_1.CountryEnum.ECountry.cn, exports.CENTRAL_STEEL), _common_enums_1$Compa3)), _exports$PHONE_NUMBER);